module.exports = __webpack_public_path__ + "img/mooc_bg.6323f391.png";